
export const ORG_NAME = '';

export const CLIENT_PORTAL_TITLE = 'Client Portal';
export const MY_ACCOUNT_TITLE = 'My Account';